(() => {
  if (window.KSBrandMonthProductsLoaded) return;
  window.KSBrandMonthProductsLoaded = true;

  const applySwatch = (swatch) => {
    const card = swatch.closest('.ks-ccard');
    if (!card) return;

    const group = swatch.closest('.product-card-swatches');
    if (group) {
      group.querySelectorAll('.product-card-swatch.active').forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-pressed', 'false');
      });
    }
    swatch.classList.add('active');
    swatch.setAttribute('aria-pressed', 'true');

    const image = card.querySelector('.ks-ccard__image');
    const srcset = (swatch.dataset.srcset || '').trim();
    if (image && srcset) {
      const firstSource = srcset.split(',')[0].trim().split(/\s+/)[0];
      image.srcset = srcset;
      if (firstSource) image.src = firstSource;
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
    }

    if (swatch.dataset.href) {
      card.querySelectorAll('.ks-ccard__media, .ks-ccard__name a, .ks-ccard__buy').forEach((link) => {
        link.href = swatch.dataset.href;
      });
    }

    const addButton = card.querySelector('[data-ks-add-to-cart]');
    if (addButton && swatch.dataset.variantId) {
      addButton.dataset.variantId = swatch.dataset.variantId;
      addButton.disabled = swatch.dataset.available === 'false';
    }

    if (swatch.dataset.priceFormatted) {
      const price = card.querySelector('.ks-ccard__price');
      if (price) {
        price.replaceChildren(document.createTextNode(swatch.dataset.priceFormatted));
        if (swatch.dataset.compareFormatted) {
          const compare = document.createElement('s');
          compare.textContent = swatch.dataset.compareFormatted;
          price.append(' ', compare);
        }
      }
    }
  };

  const bindSection = (root) => {
    if (!root || root.dataset.ksBrandMonthBound) return;
    root.dataset.ksBrandMonthBound = 'true';

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('.product-card-swatch');
      if (swatch) {
        event.preventDefault();
        event.stopPropagation();
        applySwatch(swatch);
        return;
      }

      const button = event.target.closest('[data-ks-add-to-cart]');
      if (!button || button.disabled || button.classList.contains('loading')) return;
      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');

      const addPromise = (typeof window.fetchCartAdd === 'function')
        ? window.fetchCartAdd(formData)
        : fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            body: formData
          }).then((r) => r.text()).then((text) => {
            const parsed = (typeof window.parseShopifyJson === 'function')
              ? window.parseShopifyJson(text)
              : JSON.parse(text);
            if (!parsed) throw new Error('cart-json');
            return parsed;
          });

      addPromise
        .then((response) => {
          if (typeof window.applyCartAddResponse === 'function') {
            window.applyCartAddResponse(response);
          } else if (response && response.status) {
            throw new Error(response.description || response.message || 'cart-add');
          }
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            detail: { product: response.items ? response.items[0] : response }
          }));
        })
        .catch((error) => {
          console.error('[ks-brand-month] ATC failed', error);
          if (typeof window.showCartError === 'function') {
            window.showCartError(button, error && error.message);
          }
        })
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const swatch = event.target.closest('.product-card-swatch');
      if (!swatch) return;
      event.preventDefault();
      applySwatch(swatch);
    });
  };

  const bindAll = (scope = document) => {
    scope.querySelectorAll('.section-ks-brand-month-products .ks-bmp').forEach(bindSection);
  };

  bindAll();
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
